import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { NotificationService } from 'src/app/services/notification-service';
import { ReportService } from 'src/app/services/report.service';
import { UserdataService } from 'src/app/services/userdata.service';

@Component({
    selector: 'app-statement-receipt-check',
    templateUrl: './statement-receipt-check.component.html',
    styleUrls: ['./statement-receipt-check.component.scss']
})
export class StatementReceiptCheckComponent implements OnInit {

    customerInvoiceList: any[] = [];
    toMinDate: Date;
    toMaxDate: Date;
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;

    constructor(
        private fb: FormBuilder,
        private reportService: ReportService,
        private toastr: NotificationService,
        private userDataService: UserdataService,

    ) { }
    invoiceGeneration: FormGroup;
    ngOnInit(): void {
        this.initializeValidators();
    }

    initializeValidators() {
        this.invoiceGeneration = this.fb.group({
            searchText: ['', Validators.required],
            startDate: ['', Validators.required],
            endDate: ['', Validators.required],
        });
    }

    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.invoiceGeneration.controls["startDate"].value;
        this.toMaxDate = this.addMonths(this.toMinDate, 3);
    }

    addMonths(date, months) {
        const newDate = new Date(date);
        newDate.setMonth(newDate.getMonth() + months);
        return newDate;
    }

    generateInvoice() {
        if (this.invoiceGeneration.valid) {
            let formValues = this.invoiceGeneration.getRawValue();
            this.userDataService.getUserDetailsByCustomerReference(formValues.searchText).subscribe((res: any) => {
                if (res) {
                    setTimeout(() => {
                        const payload = {
                            startDate: moment(formValues.startDate).format('YYYY/MM/DD'),
                            endDate: moment(formValues.endDate).format('YYYY/MM/DD'),
                            applicationNumber: res[0].refrenceNumber,
                            serviceProviderId: res[0].id
                        };
                        this.reportService.getCustomerStatementReceiptReport(payload).subscribe(res => {
                            if (res) {
                                const linkSource = 'data:application/pdf;base64, ' + res;
                                const downloadLink = document.createElement('a');
                                const fileName = `StatementReceiptReport.pdf`;
                                downloadLink.href = linkSource;
                                downloadLink.download = fileName;
                                downloadLink.click();
                                this.toastr.showSuccess(`Customer Statement downloaded successfully`);
                            }
                        });
                    }, 1);
                }
                else {
                    this.toastr.showError(`Customer not exist`);
                }
            });
        }
        else {
            this.toastr.showError("Please fill the details")
        }
    }

    Reset() {
        this.invoiceGeneration.reset()
    }

}
